import React, { Component } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import CustomButton from "../../../../components/buttons/customButton";
import SnackbarMessage from "../../../../components/snackBar/snackBar";

class InsertUnAssigningEmployees extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUsers: [],
            empCards: [""],
            errors: {},
            snackbar: {
                open: false,
                message: "",
                severity: "success",
            },
            status: "idle",
        };
    }

    handleAddEmpCard = () => {
        const { empCards } = this.state;
        if (empCards.length < 10) {
            this.setState((prev) => ({
                ...prev,
                empCards: [...prev.empCards, ""],
            }));
        }
    };

    handleRemoveEmployee = (index) => {
        this.setState((prev) => {
            const newEmpCards = [...prev.empCards];
            const removedUser = newEmpCards[index];

            newEmpCards.splice(index, 1);

            const newSelectedUsers = prev.selectedUsers.filter(
                (userId) => userId !== removedUser
            );

            const newErrors = { ...prev.errors };
            delete newErrors[index];

            const finalCards = newEmpCards.length > 0 ? newEmpCards : [""];

            return {
                ...prev,
                empCards: finalCards,
                selectedUsers: newSelectedUsers,
                errors: newErrors,
            };
        });
    };

    handleUserChange = (index, userId) => {
        this.setState((prev) => {
            const newSelected = [...prev.selectedUsers];
            const newCards = [...prev.empCards];

            const oldUser = newCards[index];
            if (oldUser) {
                const i = newSelected.indexOf(oldUser);
                if (i !== -1) newSelected.splice(i, 1);
            }

            if (userId) newSelected.push(userId);
            newCards[index] = userId;

            return {
                ...prev,
                selectedUsers: newSelected,
                empCards: newCards,
            };
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { empCards, selectedUsers } = this.state;
        const { stateData, handleEmptyState } = this.props;

        const errors = {};
        empCards.forEach((card, index) => {
            if (!card) errors[index] = "Please select an employee";
        });

        if (Object.keys(errors).length > 0) {
            this.setState((prev) => ({ ...prev, errors }));
            this.setState({
                snackbar: {
                    open: true,
                    message: "Please select all employees before submitting",
                    severity: "error",
                },
            });
            return;
        }

        try {
            this.setState({ status: "loading" });
            setTimeout(() => {
                this.setState({
                    snackbar: {
                        open: true,
                        message: "Employees assigned successfully",
                        severity: "success",
                    },
                    status: "success",
                });
                handleEmptyState();
            }, 500);
        } catch {
            this.setState({
                snackbar: {
                    open: true,
                    message: "Server error. Please try again.",
                    severity: "error",
                },
                status: "error",
            });
        }
    };

    render() {
        const { empCards, selectedUsers, snackbar, errors, status } = this.state;
        const { stateData } = this.props;

        const unAssignedEmployees = [];

        return (
            <>
                {unAssignedEmployees.length !== 0 ? (
                    <>
                        <p>
                            <span style={{ color: "red" }}>*</span> Available Unassigned employees are {unAssignedEmployees.length}
                        </p>
                        <Row className="g-2 mb-3">
                            {empCards.map((selected, index) => (
                                <Col key={index} xs={12} md={3}>
                                    <Card style={{ position: "relative", marginTop: "8px", marginBottom: "8px" }}>
                                        <Card.Body>
                                            <button
                                                onClick={() => this.handleRemoveEmployee(index)}
                                                style={{
                                                    position: "absolute",
                                                    top: "4px",
                                                    right: "4px",
                                                    background: index === 0 ? "green" : "#d32f2f",
                                                    border: "none",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "28px",
                                                    height: "28px",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                }}
                                                title={index === 0 ? "Clear Selection" : "Delete"}
                                            >
                                                ×
                                            </button>

                                            <Form.Group>
                                                <Form.Label>Select Employee</Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    isInvalid={!!errors[index]}
                                                    onChange={(e) =>
                                                        this.handleUserChange(index, e.target.value || null)
                                                    }
                                                    value={selected || ""}
                                                >
                                                    <option value="">-- Select --</option>
                                                    {unAssignedEmployees.map((emp) => (
                                                        <option key={emp.value} value={emp.value}>
                                                            {emp.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        <div style={{ display: "flex", justifyContent: "flex-start", gap: "12px", marginTop: "16px" }}>
                            <CustomButton
                                onClick={this.handleAddEmpCard}
                                label="Add"
                                loadingLabel="Adding..."
                            />
                        </div>

                        {selectedUsers.length > 0 && (
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "16px" }}>
                                <CustomButton
                                    status={status}
                                    onClick={this.handleSubmit}
                                    label="Submit"
                                    loadingLabel="Submitting..."
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <div style={{ textAlign: "center", marginTop: "24px" }}>No Data Found</div>
                )}

                <SnackbarMessage
                    open={snackbar.open}
                    message={snackbar.message}
                    severity={snackbar.severity}
                    onClose={() =>
                        this.setState({
                            snackbar: { open: false, message: "", severity: "success" },
                        })
                    }
                />
            </>
        );
    }
}

export default InsertUnAssigningEmployees;

